import { getGlobals } from "storyblok/api"
import { getAllBlogArticlePaths, getBlogArticle } from "storyblok/blog"
import richText from "utilities/richText"
import PageHeader from "components/DynamicComponent/molecules/PageHeader"
import ArticleSection from "components/Archive/ArticleSection"
import Meta from "components/Meta"
import { getExcerpt } from "utilities/getExcerpt"
import Script from "next/script"
import StoryblokVisualEditor from "components/StoryblokVisualEditor"

export default function Article({ story }) {
  const isNewsLetters = story?.content?.category?.includes("newsletters")

  const meta = story?.content?.twentysixty_seo

  return (
    <>
      <Meta
        info={{
          title: meta ? `${meta?.title}`:`${story?.content?.title}`,
          og_title: meta ? `${meta?.title}`:`${story?.content?.title}`,
          twitter_title: meta ? `${meta?.title}`:`${story?.content?.title}`,
          description: meta ? `${meta?.description}`:`${getExcerpt(story?.content?.content)}`,
          og_description: meta ? `${meta?.description}`:`${getExcerpt(story?.content?.content)}`,
          og_image: story?.content?.featured_image?.filename ?? null, 

        }}
      />
      <main className="main-content" data-pagefind-body data-pagefind-sort="weight[data-weight]" data-weight="6">
        <StoryblokVisualEditor story={story?.content}>
          <PageHeader
            blok={{
              type: story?.content?.featured_image?.filename?.length && !isNewsLetters ? "gradient" : "standard",
              image: !isNewsLetters ? story?.content?.featured_image : "",
              heading: story?.content?.title,
              breadcrumbs: [{ text: "Personal Injury Blog", href: "/blog" }, { text: story?.content?.title }],
            }}
          />

          <ArticleSection useCTASidebar={isNewsLetters}>{richText(story?.content?.content)}</ArticleSection>
        </StoryblokVisualEditor>
      </main>


        {
        story?.content?.schema?.code ? 
        <Script type="application/ld+json" id="blog-article-schema">
          {story?.content?.schema?.code}
        </Script> : <Script type="application/ld+json" id="blog-article-schema">
        {`{
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          "headline": "${story?.content?.title}",
          "image": [
            "${story?.content?.featured_image?.filename ?? ""}"
          ],
          "author": [{
            "@type": "Person",
            "name": "Mark Breyer",
            "url": "https://www.husbandandwifelawteam.com/team-members/mark-breyer"
          },{
            "@type": "Person",
            "name": "Alexis Breyer",
            "url": "https://www.husbandandwifelawteam.com/team-members/alexis-breyer"
        }]
        }`}
      </Script>
      }
      
    </>
  )
}

export async function getStaticProps({ params: { slug }, preview = null }) {
  const globals = await getGlobals("exclude-global-sections")
  const story = await getBlogArticle(slug, preview)

  return {
    props: {
      story: story ?? null,
      globals: globals ?? null,
      preview,
    },
  }
}

export async function getStaticPaths() {
  return {
    paths: await getAllBlogArticlePaths(),
    fallback: false,
  }
}
